import { fileNameFromUrl } from 'common/services/fileurls';

import { Comment as ServerComment } from 'server/models/Comment';

export { CommentData, CommentOptions } from 'server/models/Comment';

export class Comment extends ServerComment {
    AttachmentFileName() {
        return this.AttachmentUrl() && fileNameFromUrl(this.AttachmentUrl()!);
    }

    /**
     * The Event to which this Comment is rooted in any logs in which it appears. Mimics
     * server-side Comment.RootEvent property from PortCall.Models\Comments\Comment.cs.
     */
    RootEvent() {
        let next : Comment = this;
        while (next.SubjectEvent()?.Comment()) {
            next = next.SubjectEvent()!.Comment()!;
        }
        return next.SubjectEvent() ?? next.Event();
    }
}



// WEBPACK FOOTER //
// ./data/models/Comment.ts